import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Nav, NavLink, NavItem
} from "reactstrap";

import "react-toastify/dist/ReactToastify.css";
import Header from '../component/common/header/header';
import config from '../app/config';
import { HomeSessionsListCard } from "../component/common/sessionCard/HomeSessionsListCard";
import { LiveStreamingCard } from "./LiveStreamingCard";

const liveStreamingUrl = config.liveStreamingUrl;

const HomePortal = ({embed = false}) => {
  const [tab, setTab] = useState("1");

  return (
    <div className="page-wrapper">
      <Container fluid={true} className="product-wrapper">
        {!embed && <Header mode={tab === "1" ? "fixed" : "inline"} />}
        <div className="page-body-wrapper">
          <div className="page-body-center">
            {liveStreamingUrl &&
              <Row>
                <Nav className="border-tab-primary no-border" tabs>
                  <NavItem>
                    <NavLink
                      style={{ cursor: 'pointer' }}
                      className={tab === "1" ? "active" : ""}
                      onClick={() => setTab("1")}
                    >
                      Archivio
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: 'pointer' }}
                      className={tab === "2" ? "active" : ""}
                      onClick={() => setTab("2")}
                    >
                      Diretta Streaming
                    </NavLink>
                  </NavItem>
                </Nav>
              </Row>
            }
            <Row>
              <Col xs='0' sm="1">
              </Col>
              <Col xs='12' sm="10">
                {(tab === "1") ? <HomeSessionsListCard /> : <LiveStreamingCard />}
              </Col>
              <Col xs='0' sm="1">
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default HomePortal;
